import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import {
  TWarningModalText,
  WARNING_MODAL_TEXT,
} from '@3.0/Modals/WarningModal/WarningModal.constants';

interface IErrorModalState {
  errorMessage: string;
  warningModal: {
    isOpen: boolean;
    text: TWarningModalText;
    errorDetails: { [key: string]: string | any };
  };
}

export const errorModalInitialState: IErrorModalState = {
  errorMessage: '',
  warningModal: {
    isOpen: false,
    text: WARNING_MODAL_TEXT,
    errorDetails: {},
  },
};

export const updateErrorModalReduxSlice = {
  resetErrorModalMessage: (state: IErrorModalState) => {
    state.errorMessage = '';
  },

  updateErrorMessage: (
    state: IErrorModalState,
    action: PayloadAction<{
      error: { message: string };
    }>
  ) => {
    state.errorMessage = action.payload?.error?.message || 'Something went wrong';
  },

  openWarningModal: (
    state: IErrorModalState,
    action: PayloadAction<{
      errorDetails: { [key: string]: string | any };
      text: TWarningModalText;
    }>
  ) => {
    state.warningModal.isOpen = true;
    state.warningModal.errorDetails = action.payload.errorDetails;
    state.warningModal.text = {
      ...WARNING_MODAL_TEXT,
      messages: { ...WARNING_MODAL_TEXT.messages, ...action.payload.text.messages },
      buttons: { ...WARNING_MODAL_TEXT.buttons, ...action.payload.text.buttons },
    };
  },

  closeWarningModal: (state: IErrorModalState) => {
    state.warningModal.isOpen = false;
    state.warningModal.errorDetails = {};
    state.warningModal.text = WARNING_MODAL_TEXT;
  },
};

const ErrorModalReduxSlice = createSlice({
  name: 'errorModal',
  initialState: errorModalInitialState,
  reducers: updateErrorModalReduxSlice,
});

export const { resetErrorModalMessage, updateErrorMessage, openWarningModal, closeWarningModal } =
  ErrorModalReduxSlice.actions;

export default ErrorModalReduxSlice.reducer;
